import LocalizedStrings from 'localized-strings';

import { Section } from './sections';

const locales = new LocalizedStrings({
  en: {
    [Section.CompanyInformation]: {
      label: 'Information about the company and your client',
    },
    [Section.PersonalInformation]: {
      label: 'Your personal information',
    },
  },
  fr: {
    [Section.CompanyInformation]: {
      label: 'Les informations de la société et de votre client',
    },
    [Section.PersonalInformation]: {
      label: 'Vos informations personnelles',
    },
  },
} as const);

export default locales;
